import { redirect, type RouteObject } from "react-router-dom";

export const agentRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Agents" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => false} /> };
    },
    children: [
      { index: true, loader: () => redirect("/agents/merchant-support") },
      {
        path: "merchant-support",
        handle: { breadcrumb: "Merchant Support" },
        async lazy() {
          const { EnhancedAnalyticsPage } =
            await import("../pages/merchant-support/enhanced-analytics-page");
          return { Component: EnhancedAnalyticsPage };
        },
      },
      {
        path: "ai-ops",
        handle: { breadcrumb: "AI Ops" },
        async lazy() {
          const { AiOpsDashboard } =
            await import("../pages/ai-ops/ai-ops-dashboard");
          return { Component: AiOpsDashboard };
        },
      },
    ],
  },
];
